import { createAsyncThunk, current } from '@reduxjs/toolkit';
import axios from 'axios';
import { axiosAdmin } from '../../../utils/axiosUser';

export const initStateCommentList = {
  commentList: { data: null, loading: false, error: null },
};

export const commentList = createAsyncThunk('user/commentList', async (data, { rejectWithValue, fulfillWithValue }) => {
  return await axiosAdmin
    .get(`/comment/list`, {
      params: data,
    })
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerCommentList = {
  [commentList.pending]: (state) => {
    state.commentList.loading = true;
  },
  [commentList.fulfilled]: (state, action) => {
    state.commentList.loading = false;
    state.commentList.data = action.payload;
    state.commentList.error = null;
  },
  [commentList.rejected]: (state, action) => {
    state.commentList.data = null;
    state.commentList.loading = false;
    state.commentList.error = action.payload;
  },
};
